import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Rocket, ClipboardCheck, LifeBuoy } from 'lucide-react';

const targetGroups = [
  {
    icon: Rocket,
    title: 'Bildungsträger gründen',
    description: 'Begleitung von der Idee bis zur erfolgreichen AZAV-Trägerzulassung.',
    features: ['Strategie & Aufbau', 'QM-System', 'Unterlagen', 'Begleitung bis zum Audit']
  },
  {
    icon: ClipboardCheck,
    title: 'Audit steht bevor',
    description: 'Strukturierte Vorbereitung auf Überprüfungs- oder Maßnahmeaudits.',
    features: ['Dokumentencheck', 'Internes Audit', 'Maßnahmenplan', 'Vorbereitung auf Auditorfragen']
  },
  {
    icon: LifeBuoy,
    title: 'QM auslagern',
    description: 'Laufende Unterstützung im Qualitätsmanagement.',
    features: ['Externer QM-Beauftragter', 'Jährliche interne Audits', 'Dokumentationspflege', 'Ansprechpartner für FKS und AMDL']
  }
];

export const TargetGroups = () => {
  return (
    <section data-testid="target-groups-section" className="py-24 md:py-32 bg-[#050505] relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center max-w-3xl mx-auto mb-16"
        >
          <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block">
            Für wen wir arbeiten
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-6">
            Ihre Situation – unsere Lösung
          </h2>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed">
            Wir begleiten Bildungsträger in drei typischen Situationen.
          </p>
        </motion.div>

        {/* Target Groups Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-testid="target-groups-grid">
          {targetGroups.map((group, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="group relative bg-card/50 backdrop-blur-md border border-white/10 rounded-2xl p-8 hover:border-primary/30 transition-all duration-300"
              data-testid={`target-group-card-${index}`}
            >
              {/* Icon */}
              <div className="w-14 h-14 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center mb-6 group-hover:bg-primary/20 transition-colors">
                <group.icon className="w-7 h-7 text-primary" />
              </div>

              {/* Content */}
              <h3 className="text-xl font-heading font-semibold text-white mb-3">{group.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed mb-6">{group.description}</p>

              {/* Features */}
              <ul className="space-y-2">
                {group.features.map((feature, fIndex) => (
                  <li key={fIndex} className="flex items-center gap-2 text-sm text-muted-foreground">
                    <div className="w-1.5 h-1.5 rounded-full bg-primary" />
                    {feature}
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>

        {/* CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mt-12"
        >
          <Link to="/kontakt">
            <Button 
              data-testid="target-groups-cta"
              className="bg-primary hover:bg-[#05b873] text-black font-semibold rounded-lg px-8 py-6 text-lg transition-all duration-300"
            >
              Kostenlose Ersteinschätzung
            </Button>
          </Link>
        </motion.div>
      </div>
    </section>
  );
};
